export const blackTheme = {
  body: "#010a2e",
  text: "#ffffff",
  blue: "#1179f7",
  orange: "#ffa500",
};

export const lightTheme = {
  body: "#78b9ff",
  text: "#000000",
  blue: "#1179f7",
  orange: "#ffa500",
};

export const chosenTheme = blackTheme;
